<template>
  <span :class="objClass">
    <span class="market-change-price__value" v-html="changeValue"></span>
  </span>
</template>

<script src="./market-change-price.js"></script>
<style src="./market-change-price.scss" lang="scss"></style>
